import * as React from 'react';
import classNames from 'classnames';

// Utils
import { formatCents, isNil } from '@src/shared/src/util/general';
// Constants
// Actions, Models & Interfaces
// Components
import { Co2EmissionLabel } from '@src/components/Co2EmissionLabel';
// Styles
import '../styles/CheckoutPrice.scss';

type Props = React.PropsWithChildren & {
  label: React.ReactNode;
  price: number;
  type?: 'subtotal' | 'total';
  co2InKg?: number;
};

const CheckoutPrice: React.FC<Props> = (props) => (
  <div
    className={classNames(
      'lp-checkout-price',
      { 'is--total': props.type === 'total' },
      { 'is--subtotal': props.type === 'subtotal' },
    )}>
    <div className="lp-checkout-price-inner">
      <div className="lp-checkout-price-label">{props.label}</div>
      <div className="lp-checkout-price-container">
        <div className="lp-checkout-price-number">{formatCents(props.price)}</div>
        {!isNil(props.co2InKg) && (
          <Co2EmissionLabel value={props.co2InKg} withIcon={false} isTotal />
        )}
      </div>
    </div>
    {props.children}
  </div>
);

export default CheckoutPrice;
